import { Chip } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";
import { Box } from "@mui/system";
import { TimeServices } from "../services/functions/timeServices";
import { useEffect, useState } from "react";

export const DateRangePill = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => {
  const now = dayjs();
  const isAfterEndDate = now.isAfter(dayjs(endDate));
  const endDateJS = dayjs(endDate);

  const formattedStartDate = TimeServices.formatDate(dayjs(startDate));
  const formattedEndDate = TimeServices.formatDate(dayjs(endDate));
  const [isCritical, setIsCritical] = useState(false);


  useEffect(() => {
    const diffInSeconds = endDateJS.diff(now, "second");
    if (diffInSeconds <= 7200) { // Less than 2 hours
      setIsCritical(true);
    }
  }, [endDate]);

  if (isAfterEndDate || isCritical) return <></>;
  return (
    <Chip
      icon={<AccessTimeIcon style={{ color: "#162C1F" }} />}
      label={
        <Box sx={{ whiteSpace: 'normal', lineHeight: 1.2 }}>
          <div> {formattedStartDate} - {formattedEndDate}</div>
        </Box>
      }
      variant="outlined"
      sx={{
        alignItems: "center", // aligns icon to top if content is multi-line
        borderColor: "#162C1F",
        color: "#162C1F",
        fontWeight: "bold",
        borderRadius: "16px",
        fontSize: "0.8rem",
        padding: "6px 12px",
        borderWidth: 2,
        marginBottom: "8px",
        marginRight: "8px",
        height: 'auto',
        '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
          textAlign: 'left'
        },
      }}
    />
  );
};